/**
 * AI チャットによるコンテンツ反映時のフェード演出 util。
 * `WsFormEditChatbot.tsx` から移設し、診断・クイズ・フォームの 3 種別チャットボットで共有する。
 * 対象は `[data-section="basic"], [data-section="questions"], [data-section="results"]`。
 */

const CONTENT_SECTION_SELECTOR =
  '[data-section="basic"], [data-section="questions"], [data-section="results"]';

/**
 * コンテンツエリアのフェードアウト演出を開始する。
 */
export function startContentFadeOut(): void {
  const contentSections = document.querySelectorAll(CONTENT_SECTION_SELECTOR);

  contentSections.forEach(section => {
    section.classList.add('ai-fade-out');
  });
}

/**
 * コンテンツエリアのフェードイン演出を開始する。
 * フェードイン完了（600ms）後にクラスを除去する。
 */
export function startContentFadeIn(): void {
  const contentSections = document.querySelectorAll(CONTENT_SECTION_SELECTOR);

  contentSections.forEach(section => {
    section.classList.remove('ai-fade-out');
    section.classList.add('ai-fade-in');

    setTimeout(() => {
      section.classList.remove('ai-fade-in');
    }, 600);
  });
}

/**
 * フェード演出クラスを即時除去する。
 * setTimeout 内の反映処理が失敗した際のフォールバックとして使用する
 * （フェードアウトしたまま戻らない状態を防ぐ）。
 */
export function clearContentFade(): void {
  const contentSections = document.querySelectorAll(CONTENT_SECTION_SELECTOR);

  contentSections.forEach(section => {
    section.classList.remove('ai-fade-out', 'ai-fade-in');
  });
}
